import React from 'react';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import useStyles from './aor-run-detail.styles';

/** The map item's own input, which is where the record id survives a child-execution failure. */
const recordFromInput = (data) => {
  try {
    const input = typeof data === 'string' ? JSON.parse(data) : data;
    const row = input?.row ?? input?.BatchInput?.row ?? input;
    return row?.policyId || row?.offerId || row?.accountId || '—';
  } catch {
    return '—';
  }
};

/**
 * A child execution that failed at the Step Functions level rather than returning a report row —
 * a worker timeout, or a throttle that outlived the retries. `process-task-output` shapes these as
 * `{ cause, data }` with no id and no `error`, so without a variant of their own they match nothing,
 * fall through to the policy fallback, and render as an all-dash row with the cause nowhere on screen.
 */
const MachineFailureResultRow = ({ details }) => {
  const classes = useStyles();

  return (
    <TableRow>
      <TableCell>{recordFromInput(details.data)}</TableCell>
      <TableCell className={classes.errorCell}>{details.cause ?? '—'}</TableCell>
    </TableRow>
  );
};

MachineFailureResultRow.propTypes = {
  details: PropTypes.object.isRequired
};

export const machineFailureResultVariant = {
  key: 'machineFailures',
  label: 'machine-level failures',
  columns: ['Record', 'Cause'],
  // No id of its own — the table falls back to the row index for the React key.
  rowKey: () => null,
  matches: (details) => 'cause' in details,
  Row: MachineFailureResultRow
};

export default MachineFailureResultRow;
